"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../../namespaces");
const ResourceFilterableCollection_1 = require("./ResourceFilterableCollection");
/**
 * Provides a collection of {@link ILink} that can be filtered with relevant criteria.
 * @class
 */
class LinksCollection extends ResourceFilterableCollection_1.default {
    /**
     * Initializes a new instance of the {@link LinksCollection}
     * class with initial collections of links to filter.
     * @param {Iterable<ILink>} [links] Initial collection of links to filter.
     */
    constructor(links) {
        super(links);
    }
    /**
     * Obtains a collection of links of a given relation type.
     * @param {string} iri Expected relation type.
     * @returns {LinksCollection}
     */
    withRelationOf(iri) {
        let result = this;
        if (typeof iri === "string" && iri.length > 0) {
            result = this.narrowFiltersWith("relation", iri);
        }
        return result;
    }
    /**
     * Obtains a collection of operations being an Hydra TemplatedLink.
     * @returns {LinksCollection}
     */
    withTemplate() {
        return this.ofType(namespaces_1.hydra.TemplatedLink);
    }
    /** @inheritdoc */
    createInstance(items) {
        return new LinksCollection(items);
    }
}
exports.default = LinksCollection;
/**
 * Defines an empty links collection.
 * @constant {LinksCollection}
 */
LinksCollection.empty = new LinksCollection();
//# sourceMappingURL=LinksCollection.js.map